import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function HeroSection() {
  const featured = getFeaturedArticles().slice(0, 4);
  const mainArticle = featured[0];

  return (
    <section className="relative h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20studio%20atmosphere%20with%20warm%20spotlights%20and%20theatrical%20curtains%2C%20mysterious%20backstage%20vibe%2C%20rich%20burgundy%20and%20gold%20accents%2C%20cinematic%20lighting%2C%20professional%20broadcast%20environment%2C%20abstract%20composition%2C%20soft%20shadows%2C%20editorial%20quality&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="黑料吃瓜网"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60"></div>

      <div className="relative h-full px-4 md:px-6">
        <div className="h-full max-w-[1280px] mx-auto flex flex-col justify-end pb-10 md:pb-14">
          <div className="w-full max-w-2xl">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium border border-white/40 text-white mb-4">
              🔥 今日热门爆料
            </span>
            <Link to={`/article/${mainArticle.id}`} className="group">
              <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-3 group-hover:text-accent-300 transition-colors">
                {mainArticle.title}
              </h1>
              <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-xl line-clamp-2">
                {mainArticle.excerpt}
              </p>
            </Link>
            <div className="flex items-center gap-4 mt-4">
              <Link
                to={`/article/${mainArticle.id}`}
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                查看详情
                <i className="ri-arrow-right-line"></i>
              </Link>
              <span className="text-sm text-white/50">
                {new Date(mainArticle.publishedAt).toLocaleDateString('zh-CN')} · {Math.floor(mainArticle.viewCount / 10000)}万阅读
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}